import { type TGlobalFunctionTyped } from 'src/core/common/hooks/useTranslation';
import { TypeGuardError } from 'src/core/utils/switchGuard';

import { type DimensionName } from '../../approvalWorkflow';

export const getDimensionTitle = (
  dimension: DimensionName,
  t: TGlobalFunctionTyped,
): string => {
  switch (dimension.type) {
    case 'customField':
      return (
        dimension.name ?? t('approvalWorkflows.dimensions.customField.title')
      );
    case 'spendType':
      return t('approvalWorkflows.dimensions.spendType.title');
    case 'costCenter':
      return t('approvalWorkflows.dimensions.costCenter.title');
    case 'team':
      return t('approvalWorkflows.dimensions.team.title');
    case 'expenseCategory':
      return t('approvalWorkflows.dimensions.expenseCategory.title');
    default:
      throw new TypeGuardError(dimension, 'Unknown dimension type');
  }
};
